import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TIconSize } from '../icon.interface';

const MailIcon = forwardRef(
  ({ ...props }: TIconSize, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        width="20"
        height="16"
        viewBox="0 0 20 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.0706 1.16514e-06H6.92943C5.57533 -3.32314e-05 4.45869 -6.16014e-05 3.57494 0.118756C2.64711 0.243499 1.82769 0.515468 1.17158 1.17158C0.515468 1.82769 0.243499 2.64711 0.118756 3.57494C-6.11842e-05 4.45869 -3.30108e-05 5.57529 1.15338e-06 6.92939V9.07057C-3.30108e-05 10.4247 -6.11842e-05 11.5413 0.118756 12.4251C0.243499 13.3529 0.515468 14.1723 1.17158 14.8284C1.82769 15.4845 2.64711 15.7565 3.57494 15.8813C4.45868 16.0001 5.57527 16 6.92935 16H13.0706C14.4247 16 15.5413 16.0001 16.4251 15.8813C17.3529 15.7565 18.1723 15.4845 18.8284 14.8284C19.4845 14.1723 19.7565 13.3529 19.8813 12.4251C20.0001 11.5413 20 10.4247 20 9.07057V6.92946C20 5.57534 20.0001 4.4587 19.8813 3.57494C19.7565 2.64711 19.4845 1.82769 18.8284 1.17158C18.1723 0.515468 17.3529 0.243499 16.4251 0.118756C15.5413 -6.15939e-05 14.4247 -3.32314e-05 13.0706 1.16514e-06ZM3.02775 2.29738C3.22617 2.21497 3.48569 2.14875 3.84144 2.10092C4.57626 2.00213 5.55752 2 7 2H13C14.4425 2 15.4238 2.00213 16.1586 2.10092C16.5144 2.14876 16.774 2.215 16.9724 2.29743L10.5434 6.4574C10.2128 6.6713 9.78745 6.6713 9.45687 6.4574L3.02775 2.29738ZM2.07476 4.06291C2.00173 4.77139 2 5.69774 2 7V9C2 10.4425 2.00213 11.4238 2.10092 12.1586C2.19585 12.8646 2.36322 13.1916 2.58579 13.4142C2.80836 13.6368 3.13538 13.8042 3.84144 13.8991C4.57626 13.9979 5.55752 14 7 14H13C14.4425 14 15.4238 13.9979 16.1586 13.8991C16.8646 13.8042 17.1916 13.6368 17.4142 13.4142C17.6368 13.1916 17.8042 12.8646 17.8991 12.1586C17.9979 11.4238 18 10.4425 18 9V7C18 5.69783 17.9983 4.77151 17.9253 4.06305L11.6299 8.13654C10.6381 8.77826 9.36211 8.77826 8.37037 8.13654L2.07476 4.06291Z"
        />
      </svg>
    );
  }
);

export default MailIcon;
